import { Injectable, inject } from '@angular/core';
import { UrlTree, Router } from '@angular/router';
import { filter, Observable, take } from 'rxjs';
import { Store } from '@ngxs/store';
import { map } from 'rxjs/operators';
import { USER_ROLES } from '../enums/UserRoles.enum';
import { UserState } from '../states/user.state';

@Injectable({
  providedIn: 'root',
})
export class TvOrgChartGuard {
  private router = inject(Router);
  private store = inject(Store);
  private userRole$: Observable<USER_ROLES> = this.store.select<USER_ROLES>(UserState.userRole);

  canActivate(): Observable<boolean | UrlTree> {
    return this.userRole$.pipe(
      filter((userRole: USER_ROLES) => !!userRole),
      take(1),
      map((userRole: USER_ROLES) => {
        if (userRole !== USER_ROLES.BUDGETVERANTWORTLICHER) {
          return true;
        }

        const hasTvInOrgChart = this.store.selectSnapshot(UserState.userHasTvInOrgChart);
        if (hasTvInOrgChart) {
          return true;
        }
        return this.router.createUrlTree(['/home']);
      }),
    );
  }
}
